import { render } from "./StreamsManageSettings.vue?vue&type=template&id=c569ecb2"
import script from "./StreamsManageSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamsManageSettings.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/StreamsDash/StreamsManageSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c569ecb2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c569ecb2', __exports__)) {
    api.reload('c569ecb2', __exports__)
  }
  
  module.hot.accept("./StreamsManageSettings.vue?vue&type=template&id=c569ecb2", () => {
    api.rerender('c569ecb2', render)
  })

}


export default __exports__